import Page from 'src/components/molecules/page';
import { Container } from '@mui/material';
import { FC } from 'react';
import { ReservationList } from 'src/components/organisms/reservation/list';

export const ReservationListPage: FC = () => {
  /* 定数宣言 */
  const title = '予約リスト';

  return (
    <Page title={title}>
      <Container maxWidth={false}>
        <ReservationList />
      </Container>
    </Page>
  );
};
